import axios from "axios";
import { forEachChild } from "typescript";
import { IAddEventTeacher } from "../../../Models/Event/IAddEventTeacher";
import { IAttendeeRegistrationListItem } from "../../../Models/Event/IAttendeeRegistrationListItem";
import { IEventForTeachers } from "../../../Models/Event/IEventForTeachers";
import { IEvent } from "../../../Models/Event/IEvent";
import { IEventItem } from "../../../Models/Event/IEventItem";
import { IEventTeacherItem } from "../../../Models/Event/IEventTeacherItem";
import { IUpdateEventTeacher } from "../../../Models/Event/IUpdateEventTeacher";
import { IEventType } from "../../../Models/EventTypes/IEventType";
import { ICreateRegistration } from "../../../Models/Registration/ICreateRegistration";
import { IEventRegistrationDetail } from "../../../Models/Registration/IEventRegistrationDetail";
import { IUpdateEventRegistration } from "../../../Models/Registration/IUpdateEventRegistration";
import { IResult } from "../../../Models/Result/IResult";
import { Result } from "../../../Models/Result/Result";
import {dateToStr, strTimeToDate, strToDate, timeToStr} from "../../../Tools/DateTime";
import { formatUrl, handleError } from "../ApiHelpers";
import { IEventApi } from "./IEventApi";
import { IEventLessonsProgress } from "../../../Models/Reports/IEventLessonsProgress";
import { EventTypeEnum } from "../../../Models/Event/EventTypeEnum";

export class EventApi implements IEventApi {

    private backendUrl: string;

    constructor(url: string) {
        this.backendUrl = url;
    }

    async getEvent(id: number): Promise<IResult<IEvent>> {
        try {
            
            const url = formatUrl(this.backendUrl, `/api/Event/GetEvent/${id}`);
            const response = await axios.get(url);
            var result = response.data as IResult<IEvent>;
            if (result.data) {
                result.data.dateOfFirstLesson = strToDate(result.data.dateOfFirstLesson as string);
                result.data.registrationStart = strToDate(result.data.registrationStart as string);   
                result.data.registrationTime = strTimeToDate(result.data.registrationTime as string);
            }
            return result;
        }
        catch (error) {
            return handleError(error, "GetEventByFilterQuery");
        }
    }

    async getEventByFilterQuery(schoolYear?: number, eventType?: number, district?: string, ageGroup?: number, teacherId?: string, type?: EventTypeEnum, onlyForWeb: boolean=true): Promise<IResult<IEventItem[]>> {
        try {
            var filter = "";
            if (schoolYear && schoolYear !=0) {
                filter = filter+(filter != "" ? "&" : "?") +`SchoolYear=${schoolYear}`;
            }
            if (eventType && eventType!=0) {
                filter = filter+(filter!=""?"&":"?")+`eventType=${eventType}`;
            }
            if (district && district!="") {
                filter = filter+(filter != "" ? "&" : "?") + `district=${district}`;
            }
            if (teacherId && teacherId != "") {
                filter = filter + (filter != "" ? "&" : "?") + `teacherId=${teacherId}`;
            }
            if (ageGroup && ageGroup!=0) {
                filter = filter+(filter != "" ? "&" : "?") + `ageGroup=${ageGroup}`;
            }

            if (type !== undefined) {
                filter = filter + (filter != "" ? "&" : "?") + `type=${type}`;
            }

            filter = filter + (filter != "" ? "&" : "?") + `onlyForWeb=${onlyForWeb}`;
            
            
            const url = formatUrl(this.backendUrl, `/api/Event/GetEventByFilterQuery` + filter);
            const response = await axios.get(url);
            const res = response.data as IResult<IEventItem[]>;
            if (res.isSuccess && res.data) {
                res.data.forEach(function (part, index) {
                    if (res.data) {
                        res.data[index].registrationStart = strToDate(res.data[index].registrationStart.toString());
                        res.data[index].registrationTime = strTimeToDate(res.data[index].registrationTime.toString());
                    }
                }, res.data);  
                return Result.ok(res.data);
            }
            return response.data as IResult<IEventItem[]>;
        }
        catch (error) {
            return handleError(error, "GetEventByFilterQuery");
        }
    }
    async getAllSchoolYears(): Promise<IResult<number[]>> {
        try {

            const url = formatUrl(this.backendUrl, `/api/Event/GetAllSchoolYears`);
            const response = await axios.get(url);
            return response.data as IResult<number[]>;
        }
        catch (error) {
            return handleError(error, "GetEventByFilterQuery");
        }
    }

    async getEventByTeacher(schoolYear?: number): Promise<IResult<IEventItem[]>> {
        try {
            var filter = "";
            if (schoolYear && schoolYear != 0) {
                filter = filter + (filter != "" ? "&" : "?") + `SchoolYear=${schoolYear}`;
            }
            const url = formatUrl(this.backendUrl, `/api/Event/GetEventByTeacherQuery` + filter);
            const response = await axios.get(url);
            const res = response.data as IResult<IEventItem[]>;
            if (res.isSuccess && res.data) {
                res.data.forEach(function (part, index) {
                    if (res.data) {
                        res.data[index].registrationStart = strToDate(res.data[index].registrationStart.toString());
                    }
                }, res.data);
                return Result.ok(res.data);
            }
            return response.data as IResult<IEventItem[]>;
        }
        catch (error) {
            return handleError(error, "GetEventByFilterQuery");
        }
    }

    async getEventRegistredByUser(): Promise<IResult<IEventItem[]>> {
        try {

            const url = formatUrl(this.backendUrl, `/api/Event/GetEventRegistredByUser`);
            const response = await axios.get(url);
            return response.data as IResult<IEventItem[]>;
        }
        catch (error) {
            return handleError(error, "GetEventByFilterQuery");
        }
    }

    async getEventRegistredByUserAdmin(userId:string,attendeeId?:number): Promise<IResult<IEventItem[]>> {
        try {
            var filter = "";
 
            if (attendeeId && attendeeId != 0) {
                filter = filter + (filter != "" ? "&" : "?") + `attendeeId=${attendeeId}`;
            }
            if (userId && userId != "") {
                filter = filter + (filter != "" ? "&" : "?") + `userId=${userId}`;
            }
            
            filter = filter + (filter != "" ? "&" : "?")  ;


            const url = formatUrl(this.backendUrl, `/api/Event/GetEventRegistredByUserAdmin${filter}`);
            const response = await axios.get(url);
            return response.data as IResult<IEventItem[]>;
        }
        catch (error) {
            return handleError(error, "getEventRegistredByUserAdmin");
        }
    }

    async createEvent(event: IEvent): Promise<IResult<number>> {
        try {
            const e = { ...event };
            e.dateOfFirstLesson = dateToStr(e.dateOfFirstLesson as Date);
            e.registrationStart = dateToStr(e.registrationStart as Date);
            e.registrationTime = timeToStr(e.registrationTime as Date);
            const url = formatUrl(this.backendUrl, `/api/Event/CreateEvent`);
            const response = await axios.post(url, e);
            return response.data as IResult<number>;
        }
        catch (error) {
            return handleError(error, "createEvent");
        }
    }

    async updateEvent(event: IEvent): Promise<IResult<string>> {
        try {
            const e = { ...event };

            console.log(e.registrationStart);
            
            e.dateOfFirstLesson = dateToStr(e.dateOfFirstLesson as Date);
            e.registrationStart = dateToStr(e.registrationStart as Date);
            e.registrationTime = timeToStr(e.registrationTime as Date);
            const url = formatUrl(this.backendUrl, `/api/Event/UpdateEvent/${e.id}`);
            const response = await axios.put(url, e);
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "updateEvent");
        }
    }

    async deleteEvent(id: number): Promise<IResult<string>> {
        try {

            const url = formatUrl(this.backendUrl, `/api/Event/DeleteEvent/${id}`);
            const response = await axios.delete(url);
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "deleteEvent");
        }
    }

    async getEventRegistrationsWithInvoice(eventId?: number,userId?:string): Promise<IResult<IAttendeeRegistrationListItem[]>> {
        try {
            var filter = "";
            if (eventId && eventId != 0) {
                filter = filter + (filter != "" ? "&" : "?") + `eventId=${eventId}`;
            }
            if (userId && userId != '') {
                filter = filter + (filter != "" ? "&" : "?") + `userId=${userId}`;
            }
            filter = filter + (filter != "" ? "&" : "?");

            const url = formatUrl(this.backendUrl, `/api/Event/GetEventRegistrationsWithInvoice${filter}`);
            const response = await axios.get(url);
            var result = response.data as IResult<IAttendeeRegistrationListItem[]>;
            if (result.data) {
                result.data = result.data.map(x => { return { ...x, dateOfBirth: new Date(x.dateOfBirth), key: x.id.toString() } })
            }
            console.log(result);
            return result;
        }
        catch (error) {
            return handleError(error, "getEventRegistrationsWithInvoice");
        }
    }

    async getEventForTeachers(id: number): Promise<IResult<IEventForTeachers>> {

        try {

            const url = formatUrl(this.backendUrl, `/api/Event/GetEventRegistrationsForTeachers/${id}`);
            const response = await axios.get(url);
            var result = response.data as IResult<IEventForTeachers>;
            if (result.data) {
                result.data.registrations = result.data.registrations.map(x => { return { ...x, key: x.id.toString() } })
            }
            return result;
        }
        catch (error) {
            return handleError(error, "getEventRegistrationsForTeachers");
        }
    }

    async getUsersEventRegistrationDetail(evetId: number): Promise<IResult<IEventRegistrationDetail>> {
        try {

            const url = formatUrl(this.backendUrl, `/api/Event/GetUsersEventRegistrationDetail/${evetId}`);
            const response = await axios.get(url);
            var result = response.data as IResult<IEventRegistrationDetail>;
            if (result.data) {
                result.data.firstLesson = strToDate(result.data.firstLesson.toString())
            }
            return result;
        }
        catch (error) {
            return handleError(error, "getUsersEventRegistrationDetail");
        }
    }

    async findRegistration(eventTypeId?: number, eventId?: number, name?: string): Promise<IResult<IAttendeeRegistrationListItem[]>> {
        try {
            var filter = "";
            if (eventId && eventId != 0) {
                filter = filter + (filter != "" ? "&" : "?") + `eventId=${eventId}`;
            }
            if (eventTypeId && eventTypeId != 0) {
                filter = filter + (filter != "" ? "&" : "?") + `eventTypeId=${eventTypeId}`;
            }
            if (name && name != "") {
                filter = filter + (filter != "" ? "&" : "?") + `name=${name}`;
            }
            const url = formatUrl(this.backendUrl, `/api/Event/findRegistration`+ filter)
            const response = await axios.get(url);
            var result = response.data as IResult<IAttendeeRegistrationListItem[]>;
            if (result.data) {
                result.data = result.data.map(x => { return { ...x, dateOfBirth: new Date(x.dateOfBirth), key: x.id.toString() } })
            }
            return result;
        }
        catch (error) {
            return handleError(error, "getEventAttendee");
        }
    }

    async sendRegistrationByEmail(registrationId: number): Promise<IResult<null>> {
        try {

            const url = formatUrl(this.backendUrl, `/api/Event/SendRegistrationByEmail/${registrationId}`);
            const response = await axios.get(url);
            var result = response.data as IResult<null>;
            return result;
        }
        catch (error) {
            return handleError(error, "sendRegistrationByEmail");
        }
    }


    async uploadProfileImage(eventId: number, file: File, callback?: (progress: number, fileName: string) => void): Promise<IResult<string>> {
        var data = new FormData();
        data.append('eventId', eventId.toString());
        data.append('file', file);
        var config = {
            onUploadProgress: function (progess: any) {
                var percentCompleted = Math.round((progess.loaded * 100) / progess.total);
                callback && callback(percentCompleted, file.name);
            }
        };
        try {
            const url = formatUrl(this.backendUrl, `/api/Event/UploadProfileImage`);
            const response = await axios.post(url, data, config);
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "uploadImage");
        }
    }

    async createEventRegistration(eventId:number,registrations: ICreateRegistration[]): Promise<IResult<number[]>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Event/CreateEventRegistration/${eventId}`);
            const response = await axios.post(url, registrations);
            return response.data as IResult<number[]>;
        }
        catch (error) {
            return handleError(error, "createEventRegistration");
        }
    }

    async updateEventRegistration(registration: IUpdateEventRegistration): Promise<IResult<null>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Event/UpdateEventRegistration/${registration.registrationId}`);
            
            const response = await axios.post(url, registration);
            return response.data as IResult<null>;
        }
        catch (error) {
            return handleError(error, "updateEventRegistration");
        }
    }


    async getEventTeachers(id: number): Promise<IResult<IEventTeacherItem[]>> {
        try {

            const url = formatUrl(this.backendUrl, `/api/Event/GetEventTeachers/${id}`);
            const response = await axios.get(url);
            var result = response.data as IResult<IEventTeacherItem[]>;
            if (result.data) {
                result.data = result.data.map(item => {
                    const r: IEventTeacherItem = { ...item, key: item.id };
                    return r
                });            
            }
            return result;
        }
        catch (error) {
            return handleError(error, "getEventTeachers");
        }
    }

    async addEventTeacher(id:number,teacher: IAddEventTeacher): Promise<IResult<number>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Event/AddTeacher/${id}`);
            const response = await axios.post(url, teacher);
            return response.data as IResult<number>;
        }
        catch (error) {
            return handleError(error, "addEventTeacher");
        }
    }

    async updateEventTeacher(id:number, teacher: IUpdateEventTeacher): Promise<IResult<number>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Event/UpdateTeacherCommand/${id}`);
            const response = await axios.post(url, teacher);
            return response.data as IResult<number>;
        }
        catch (error) {
            return handleError(error, "addEventTeacher");
        }
    }

    async removeEventTeacher(id: number, teacherId: number): Promise<IResult<boolean>> {

        try {
            const url = formatUrl(this.backendUrl, `/api/Event/DeleteTeacherCommand/${id}?teacherId=${teacherId}`);
            const response = await axios.delete(url);
            return response.data as IResult<boolean>;
        }
        catch (error) {
            return handleError(error, "removeEventTeacher");
        }
    }

    async reportEventLessonsProgress(year: number): Promise<IResult<IEventLessonsProgress[]>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Event/ReportEventLessonsProgress/${year}`);
            const response = await axios.get(url);
            return response.data as IResult<IEventLessonsProgress[]>;
        }
        catch (error) {
            return handleError(error, "reportEventLessonsProgress");
        }
    }
}